import type { ScopedThreadRef } from "@amoreg/contracts";

import { usePreviewSession } from "./usePreviewSession";

/**
 * Keeps a chat's preview tabs in sync while its browser panel is closed.
 *
 * Only the panel (`PreviewView`) subscribes to preview tabs, and the desktop
 * automation host does it in Electron. On the web, a browser the agent opens
 * from a chat with the panel closed never reached the client, so the
 * mini-player auto-open in `ChatView` had no tab to show (AMO-150). The
 * subscription is the panel's own, shared per thread, so mounting both costs
 * no second stream.
 */
export function CloudPreviewSessionSync({ threadRef }: { readonly threadRef: ScopedThreadRef }) {
  usePreviewSession(threadRef);
  return null;
}
